import React from 'react';

const TIMER_STARTING_POINT = 60;

export function useResendCodeInterval() {
  // Separating startingPoint and secsUntilResend prevents the interval effect from
  // being dependent on the state that it sets, which would cause an infinite loop.
  const [startingPoint, setStartingPoint] = React.useState(0);
  const [secsUntilResend, setSecsUntilResend] = React.useState(TIMER_STARTING_POINT);
  const [resetTimerCount, setResetTimerCount] = React.useState(0);

  React.useEffect(() => {
    if (!startingPoint) return;

    let interval: NodeJS.Timeout;
    setSecsUntilResend(startingPoint);
    interval = setInterval(() => {
      setSecsUntilResend((prev) => {
        const next = prev - 1;
        if (next >= 0) return next;
        clearInterval(interval);
        return 0;
      });
    }, 1_000);
    return () => clearInterval(interval);
  }, [startingPoint, resetTimerCount]);

  function resetTimer() {
    setSecsUntilResend(TIMER_STARTING_POINT);
    setStartingPoint(TIMER_STARTING_POINT);
    setResetTimerCount((prev) => prev + 1);
  }

  function clearTimer() {
    setSecsUntilResend(0);
    setStartingPoint(0);
  }

  return { secsUntilResend, resetTimer, clearTimer };
}
